<template>
    <div class="component-container">
        <div class="logo-container">
          <img src="https://sander-gruppe.eu/wp-content/uploads/2019/07/ms-logo.png" alt="Ihr Logo" class="logo" @click="goBack">
        </div>
        <div class="component-container-header">
            Profil / Stammdatenverwaltung
        </div>
      <!-- Ersetzen Sie dies mit dem tatsächlichen Inhalt basierend auf dem Bild -->
        <div class="flex-top">
            <div class="company">
                <div class="header">Firma</div>
                <div class="flex-down">
                    <div class="content-row"><div class="left-content">Kd-Nr.:</div><div class="right-content">{{ company != null ? company.kdnr : "" }}</div></div>
                    <div class="content-row"><div class="left-content">Firma:</div><div class="right-content">{{ company != null ? company.name : "" }}</div></div>
                    <div class="content-row"><div class="left-content">Straße:</div><div class="right-content">{{ company != null ? company.strasse : "" }}</div></div>
                    <div class="content-row"><div class="left-content">PLZ/Ort:</div><div class="right-content">{{ company != null ? company.plzort : "" }}</div></div>
                    <!-- <div class="content-row"><div class="left-content">Region:</div><div class="right-content">{{ company != null ? company.region : "" }}</div></div> -->
                    <div class="content-row"><div class="left-content">Email-Rg.:</div><div class="right-content">{{ company != null ? company.email_rg : "" }}</div></div>
                    <div class="content-row"><div class="left-content">Email-AB:</div><div class="right-content">{{ company != null ? company.email_ab : "" }}</div></div>
                </div>
                <!-- Fügen Sie weitere Felder entsprechend dem Bild hinzu -->
            </div>
        </div>
        <div class="flex-middle">
            <!-- <div class="your-notes">
                <div class="header">Notizen</div>
                <div class="flex-down">
                    <div class="content-row">"Speergrund / Adresszeile 3"</div>
                </div>

            </div> -->
            <div class="contact-data">
                <div class="header">Ihre Kontaktdaten</div>
                <div class="flex-down">
                    <div class="content-row"><div class="left-content">AP:</div><div class="right-content">{{ loggedInUser != null ? loggedInUser.name : "" }}</div></div>
                    <!--<div class="content-row"><div class="left-content">Position:</div><div class="right-content">{{ loggedInUser != null ? loggedInUser.position : "" }}</div></div>-->
                    <div class="content-row"><div class="left-content">Tel.:</div><div class="right-content">{{ loggedInUser != null ? loggedInUser.tel : "" }}</div></div>
                    <div class="content-row"><div class="left-content">Mobil:</div><div class="right-content">{{ loggedInUser != null ? loggedInUser.mobil : "" }}</div></div>
                    <div class="content-row"><div class="left-content">Email:</div><div class="right-content">{{ loggedInUser != null ? loggedInUser.email : "" }}</div></div>
                </div>
                <!-- Fügen Sie weitere Felder entsprechend dem Bild hinzu -->
            </div>
            <!-- <div class="helpline">
                <div class="header">Sie brauchen Hilfe?</div>
                <div class="flex-down">
                    <div class="content-row">Helpline</div>
                    <div class="content-row">02915-98 490-0</div>
                </div>
            </div> -->
        </div>
        <div class="flex-middle">
            <div v-if="!sBedNummer.includes('ABH')" class="your-shipping-address">
                <div class="header">Ihre Lieferadresse</div>
                <div class="flex-down">
                    <div class="content-row"><div class="left-content">Firma:</div><div class="right-content">{{ company != null ? company.name : "" }}</div></div>
                    <div class="content-row"><div class="left-content">AP:</div><div class="right-content">{{ loggedInUser != null ? loggedInUser.name : "" }}</div></div>
                    <div class="content-row"><div class="left-content">Tel:</div><div class="right-content">{{ loggedInUser != null ? loggedInUser.tel : "" }}</div></div>
                    <div class="content-row"><div class="left-content">Email:</div><div class="right-content">{{ loggedInUser != null ? loggedInUser.email : "" }}</div></div>
                    <div class="content-row"><div class="left-content">Straße:</div><div class="right-content">{{ company != null ? company.strasse : "" }}</div></div>
                    <div class="content-row"><div class="left-content">PLZ/Ort:</div><div class="right-content">{{ company != null ? company.plzort : "" }}</div></div>
                    <!-- <div class="content-row"><div class="left-content">Region:</div><div class="right-content">{{ company != null ? company.region : "" }}</div></div> -->
                </div>
                <!-- Fügen Sie weitere Felder entsprechend dem Bild hinzu -->
            </div>
            <div v-else-if="sBedNummer.includes('ABH')" class="your-shipping-address">
                <div class="header">Ihre Lieferaddresse</div>
                <div class="flex-down">
                    <div class="content-row">Abholung durch den Kunden</div>
                </div>
                <!-- Fügen Sie weitere Felder entsprechend dem Bild hinzu -->
            </div>
        </div>
        <div class="flex-bottom">
            <div class="discount">
            <div class="header">Rabatt</div>
                <div class="flex-down">
                    <div
                      v-for="item in filteredDiscounts"
                      :key="item.index"
                      class="content-row"
                    >
                        <div class="left-content">
                            {{ discountName[item.index] }}
                        </div>
                        <div v-if="!isNaN(item.discount)" class="right-content">
                            {{ item.discount.toString().replace('.', ',') }}%
                        </div>
                        <div v-else class="right-content">
                            -
                        </div>
                    </div>
                </div>
            </div>
            <div class="overall-information">
                <div class="header">Liefer-/ Versand-/ Zahlungsbedingungen</div>
                <div class="flex-down">
                    <div v-if="lBedBezeichnung" class="content-row">
                        <div class="left-content">
                            Lieferbedingungen
                        </div>
                        <div class="right-content">
                            {{ lBedBezeichnung }}
                        </div>
                    </div>
                    <div v-if="sBedBezeichnung" class="content-row">
                        <div class="left-content">
                            Versandbedingungen
                        </div>
                        <div class="right-content">
                            {{ sBedBezeichnung }}
                        </div>
                    </div>
                    <div v-if="pBedBezeichnung" class="content-row">
                        <div class="left-content">
                            Zahlungsbedingungen
                        </div>
                        <div class="right-content">
                            {{ pBedBezeichnung }}
                        </div>
                    </div>
                    <div class="content-row">
                        <div class="left-content">
                            Teuerungszuschlag
                        </div>
                        <div class="right-content">
                            {{ tz.toFixed(1).toString().replace('.', ',') }}%
                        </div>
                    </div>
                </div>
                <!-- Fügen Sie weitere Felder entsprechend dem Bild hinzu -->
            </div>
            <div class="button-container">
                <button class="button-with-icon" @click="goBack">
                    <img class="icon-in-button" :src="require('@/assets/dashboard/house-solid-dark-grey.svg')" alt="Icon" />
                    Zum Dashboard
                </button>
            </div>
        </div>
        <div class="component-container-notice">
            <div class="profile-data-bold">Ihre Daten haben sich geändert?</div>
            <div>Geben Sie uns einfach <a href="mailto:info@ms-sprossenelemente.de">hier</a> Bescheid, damit wir Ihre Stammdaten für zukünftige Konfigurationen anpassen können.</div>
        </div>
        <LegalFooter />
      <!-- Fügen Sie weitere Abschnitte entsprechend dem Bild hinzu -->
    </div>
</template>
  
<script>
import api from '@/api/client';
import LegalFooter from './LegalFooter.vue';

  export default {
    name: 'ProfileData',
    components: {
      LegalFooter,
    },
    data() {
      return {
        company: null,
        loggedInUser: null,
        discountName: [
            "Grundrabatt:",
            "100/200 Rabatt:",
            "300 Rabatt:",
            "400 Rabatt:",
            "500 Rabatt:",
            "600 Rabatt:",
            "700 Rabatt:",
            "800 Rabatt:",
            "900 Rabatt:",
            "P20 Rabatt:",
            "P45 Rabatt:",
            "Zubehör Rabatt:"
        ],
        discounts: [],
        notes: {
          content: ''
        },
        sBedBezeichnung: null,
        pBedBezeichnung: null,
        lBedBezeichnung: null,
        sBedNummer: "",
        tz: 0.0,
      }
    },
    computed: {
      filteredDiscounts() {
        return this.discounts
          .map((discount, index) => ({ discount, index }))
          .filter(item => 
            item.index > 0 &&
            this.discountName[item.index] &&
            this.discountName[item.index].toString().trim() != ''
          );
      }
    },

    methods: {
        goBack() {
            this.$parent.changeMenuState(3, { replaceHistory: true });
        },
        async refreshProfileData() {
            this.lBedBezeichnung = null;
            this.pBedBezeichnung = null;
            this.sBedBezeichnung = null;
            this.company = this.$parent.getCompany();
            this.loggedInUser = this.$parent.getLoggedInUser();
            this.discounts = []
            try {
                const response = await api.get(`/api/discounts/unternehmen/${this.company.id}`);
                // Negative Rabatte wie Teuerungszuschlag
                let extraCharge = response.data.filter(item => item.type == 1);
                for (let i = 0; i < extraCharge.length; ++i) {
                    // 10 Teuerungsaufschlag
                    if (extraCharge[i].kuerzel == "TZ") {
                        // Backend liefert hier teils Strings (ggf. mit Komma). Immer in Number wandeln,
                        // damit toFixed im Template nicht auf einem String aufgerufen wird.
                        const parsedTz = parseFloat(String(extraCharge[i].rabatt).replace(',', '.'));
                        this.tz = isNaN(parsedTz) ? 0.0 : parsedTz;
                    }
                }
                
                // Nur die discounts für die Beschläge
                response.data = response.data.filter(item => item.type == 0);
                response.data.forEach(dataSet => {
                    const position = Number(dataSet.position);
                    if (!Number.isInteger(position) || position < 0) return;

                    this.discounts[position] = Number(dataSet.rabatt) % 1 !== 0 ? Number(dataSet.rabatt).toFixed(2) : Number(dataSet.rabatt).toFixed(0);
                });
                for (let i = 0; i < this.discountName.length; ++i) {
                    if (this.discounts[i] !== undefined) continue;

                    this.discounts[i] = '0';
                }
                const responseDelivery = await api.get(`/api/delivery_conditions/${this.company.delivery_condition_id}`);
                if (responseDelivery.data && responseDelivery.data.length > 0) {
                    this.lBedBezeichnung = responseDelivery.data[0].l_bed_bezeichnung;
                }
                const responsePayment = await api.get(`/api/payment_conditions/${this.company.payment_condition_id}`);
                if (responsePayment.data && responsePayment.data.length > 0) {
                    this.pBedBezeichnung = responsePayment.data[0].p_bed_bezeichnung;
                }
                const responseShipment = await api.get(`/api/shipment_conditions/${this.company.shipment_condition_id}`);
                if (responseShipment.data && responseShipment.data.length > 0) {
                    this.sBedNummer = responseShipment.data[0].s_bed_nummer;
                    this.sBedBezeichnung = responseShipment.data[0].s_bed_bezeichnung;
                }
            } catch (error) {
                console.error(error);
            }
           
        }
    },
  }
</script>

<style scoped src="@/styles/ProfileDataComponent.css">

</style>
